import {
  applyAutoBackgroundRemovalFromDataUrl,
  applyBackgroundRemovalFromDataUrl,
} from "@/home/remove-white-bg";
import type Phaser from "phaser";

/** Load a data: URL into an image without Phaser Loader (avoids huge XHR → 431). */
export function loadHtmlImageFromDataUrl(dataUrl: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("โหลดภาพไม่สำเร็จ"));
    img.src = dataUrl;
  });
}

export function isDataUrl(url: string): boolean {
  return url.startsWith("data:");
}

/** Register a horizontal skill strip as a Phaser spritesheet (6 frames in one row). */
export function addSkillSpritesheetTexture(
  textures: Phaser.Textures.TextureManager,
  key: string,
  dataUrl: string,
  frameWidth: number,
  frameHeight: number,
): Promise<void> {
  const fw = Math.max(1, Math.round(frameWidth));
  const fh = Math.max(1, Math.round(frameHeight));
  return applyAutoBackgroundRemovalFromDataUrl(dataUrl).then((cleaned) =>
    loadHtmlImageFromDataUrl(cleaned).then((img) => {
      if (textures.exists(key)) {
        textures.remove(key);
      }
      textures.addSpriteSheet(key, img, {
        frameWidth: fw,
        frameHeight: fh,
      });
    }),
  );
}

/** Rank badge overhead: strip light sheet background, keep badge frame colors from art. */
export function addRankBadgeSpritesheetTexture(
  textures: Phaser.Textures.TextureManager,
  key: string,
  dataUrl: string,
  frameWidth: number,
  frameHeight: number,
): Promise<void> {
  const fw = Math.max(1, Math.round(frameWidth));
  const fh = Math.max(1, Math.round(frameHeight));
  return applyBackgroundRemovalFromDataUrl(dataUrl, { removeWhite: true }).then((cleaned) =>
    loadHtmlImageFromDataUrl(cleaned).then((img) => {
      if (textures.exists(key)) {
        textures.remove(key);
      }
      textures.addSpriteSheet(key, img, {
        frameWidth: fw,
        frameHeight: fh,
      });
    }),
  );
}

/** Overhead badge: full sheet as one image (not a single animation frame). */
export function addRankBadgeOverheadImageTexture(
  textures: Phaser.Textures.TextureManager,
  key: string,
  dataUrl: string,
): Promise<void> {
  return applyBackgroundRemovalFromDataUrl(dataUrl, { removeWhite: true }).then((cleaned) =>
    loadHtmlImageFromDataUrl(cleaned).then((img) => {
      if (textures.exists(key)) {
        textures.remove(key);
      }
      textures.addImage(key, img);
    }),
  );
}
